import request from '@/utils/request'
import locale from './../lang/i18n'
import { adminPath, paged, updateSettings, uploadMedia } from './adminV1'

function publicLocale () {
  return locale.locale === 'en-US' ? 'en' : 'zh-cn'
}

function payload (data) {
  const coverUrl = data.coverUrl || (typeof data.indexSrcId === 'string' ? data.indexSrcId : '')
  return {
    title: data.title,
    content: data.content,
    publishDate: data.publishDate,
    coverUrl,
    slug: data.slug,
    translationGroup: data.translationGroup,
    seoTitle: data.seoTitle,
    metaDescription: data.metaDescription,
    coverAlt: data.coverAlt || data.title,
    publishStatus: data.publishStatus || 'PUBLISHED'
  }
}

export function addCustomerCase (data) {
  return request({ url: adminPath('/case-studies'), method: 'post', data: payload(data) })
    .then(result => ({ code: 0, data: result }))
}

export function updateCustomerCase (data) {
  const id = data.id || data.customerCaseId
  return request({ url: adminPath(`/case-studies/${id}`), method: 'put', data: payload(data) })
    .then(result => ({ code: 0, data: result }))
}

export function deleteCustomerCase (id) {
  return request({ url: adminPath(`/case-studies/${id}`), method: 'delete' })
    .then(() => ({ code: 0 }))
}

export function uploadCaseCover (file) {
  return uploadMedia(file, 'image').then(media => ({
    code: 0,
    data: { ...media, id: media.url }
  }))
}

export function uploadCustomerCaseImage (file, kind = 'image') {
  return uploadMedia(file, kind).then(data => ({ code: 0, data }))
}

export function getCustomerCaseList (data) {
  const query = data || {}
  return request({ url: `/api/public/v1/${publicLocale()}/case-studies`, method: 'get' }).then(list => {
    const page = paged(list, query)
    return {
      code: 0,
      data: {
        data: page.rows.map(item => ({
          ...item,
          id: item.slug,
          indexSrc: { url: item.coverUrl },
          author: '智会云科技'
        })),
        total: page.total
      }
    }
  })
}

export function getAdminCaseList (data) {
  const query = data || {}
  return request({
    url: adminPath('/case-studies/page'),
    method: 'get',
    params: {
      pageNum: query.pageNum,
      pageSize: query.pageSize,
      searchTitle: String(query.searchTitle || '').trim() || undefined
    }
  }).then(page => ({ code: 0, data: { data: page.rows, total: page.total } }))
}

export function getContent (slug) {
  return request({
    url: `/api/public/v1/${publicLocale()}/case-studies/${encodeURIComponent(slug)}`,
    method: 'get'
  }).then(data => ({ code: 0, data: { content: { title: data.title, content: data.content } } }))
}

export function getAdminCaseById (id) {
  return request({ url: adminPath(`/case-studies/${id}`), method: 'get' }).then(data => ({
    code: 0,
    data: {
      content: data,
      indexSrc: { id: data.coverUrl, url: data.coverUrl }
    }
  }))
}

export function settingTopBackground (file) {
  return uploadMedia(file, 'image')
    .then(media => updateSettings({ caseStudyTopImage: media.url }))
    .then(data => ({ code: 0, data }))
}

export function getTopBackground () {
  return request({ url: adminPath('/settings'), method: 'get' })
    .then(data => ({ code: 0, data: { value: data.caseStudyTopImage || '' } }))
}

export function getWebTopBackground () {
  return request({ url: `/api/public/v1/${publicLocale()}/media/CUSTOMER_CASE_TOP_IMG`, method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function getCasesListAll () {
  return request({ url: `/api/public/v1/${publicLocale()}/case-studies`, method: 'get' })
    .then(list => ({
      code: 0,
      data: (list || []).map(item => ({
        ...item,
        id: item.slug,
        indexSrc: { url: item.coverUrl }
      }))
    }))
}
